module.exports = __webpack_public_path__ + "media/images/home/ic_meet-8862035a0d3e4377354ccf52767378b8.svg";